import { LoadingOverlay } from '@mantine/core';
import CollapsibleDevPanelSection from './CollapsibleDevPanelSection';
import ObjectFieldsTable from './ObjectFieldsTable';
import NestedObjectFieldsTable from './NestedObjectFieldsTable';

const ObjectFieldsSection = ({
  title,
  document,
}: {
  title: string;
  document: object | undefined;
}) => {
  return (
    <CollapsibleDevPanelSection title={title}>
      {!document && <LoadingOverlay visible={true} />}
      {document && <NestedObjectFieldsTable obj={document} />}
    </CollapsibleDevPanelSection>
  );
};

export default ObjectFieldsSection;
